module.exports = __webpack_public_path__ + "img/dreams-mini-landscape.623c67f.png";